import { createFileRoute } from '@tanstack/react-router'
import IrrigationOperationForm from '@/components/field/operations/IrrigationOperationForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { Button } from '@heroui/react'
import { Link, useParams } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute(
    '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId',
)({
    component: RouteComponent,
})

function RouteComponent() {
    const { irrigationOperationId, fieldId } = useParams({
        from: '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId',
    })
    const { t } = useTranslation('operations')

    return (
        <div className="p-2">
            <Button
                size="sm"
                as={Link}
                to="/dashboard/fields/$fieldId/operations"
                className="mb-2"
                params={
                    {
                        fieldId,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } as any
                }
            >
                <FontAwesomeIcon icon={faChevronLeft} /> {t('backToOperations')}
            </Button>
            <IrrigationOperationForm
                existingIrrigationId={Number(irrigationOperationId)}
            />
        </div>
    )
}
